var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorking1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "32,10.933 44.141,10.933  44.141,15.254 32,15.254  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "32,26.134 50.67,26.134  50.67,33.296  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 46.348,
    y1: 36.335,
    x2: 32,
    y2: 36.335
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "32,39.804 39.986,39.804  41.525,38.03 40.563,36.335 32,36.335  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "44.141,10.933 32,13.177  44.141,15.254  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: "M50.191,15.254 c-1.801-2.324-2.691-4.196-6.05-4.321"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 50.67,26.134 53.661,22.971 50.874,16.135  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M49.967,40.552c2.017,0,3.662-1.645,3.662-3.662s-1.646-3.661-3.662-3.661s-3.661,1.645-3.661,3.661S47.951,40.552,49.967,40.552z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M32,46.208h14.079v5.329c0,0.841,0.689,1.53,1.53,1.53h9.387c0.839,0,1.53-0.69,1.53-1.53v-18.49l-2.245-4.669"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 58.526,33.047 53.628,36.891 58.526,50.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 50.67,32.561 56.281,28.378 53.661,22.971 50.67,26.134  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M56.281,28.378c1.582-0.05,3.018-0.698,4.361-1.734c0.297-1.397,0.009-2.617-0.816-3.673h-6.166L56.281,28.378z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 39.448,36.335 32,33.377 50.67,26.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 46.079,46.208 46.348,36.335 39.986,39.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,41.946 39.986,39.804 46.079,46.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 46.103,45.363 50.115,40.549 46.073,50.369  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 53.628,36.891 58.526,50.823 50.115,40.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 50.67,26.134 47.475,17.884 50.191,15.254 50.874,16.135  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 44.141,15.254 45.564,15.254 47.475,17.884  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 50.191,
    y1: 15.254,
    x2: 45.565,
    y2: 15.254
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,10.933 19.859,10.933 19.859,15.254 32,15.254  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,26.134 13.33,26.134 13.33,33.296  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 17.653,
    y1: 36.335,
    x2: 32,
    y2: 36.335
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,39.804 24.015,39.804 22.475,38.03 23.436,36.335 32,36.335  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 19.859,10.933 32,13.177 19.859,15.254  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M13.809,15.254c1.802-2.324,2.691-4.196,6.051-4.321"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 13.33,26.134 10.339,22.971 13.126,16.135  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M14.033,40.552c2.017,0,3.662-1.645,3.662-3.662s-1.645-3.661-3.662-3.661s-3.662,1.645-3.662,3.661S12.017,40.552,14.033,40.552z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M32,46.208H17.921v5.329c0,0.841-0.69,1.53-1.531,1.53H7.004c-0.84,0-1.53-0.69-1.53-1.53v-18.49l2.245-4.669"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 5.474,33.047 10.372,36.891 5.474,50.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 13.33,32.561 7.719,28.378 10.339,22.971 13.33,26.134  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M7.719,28.378c-1.581-0.05-3.018-0.698-4.361-1.734c-0.297-1.397-0.009-2.617,0.816-3.673h6.166L7.719,28.378z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 24.553,36.335 32,33.377 13.33,26.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 17.921,46.208 17.653,36.335 24.015,39.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,41.946 24.015,39.804 17.921,46.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 17.898,45.363 13.886,40.549 17.927,50.369  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 10.372,36.891 5.474,50.823 13.886,40.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 13.33,26.134 16.524,17.884 13.809,15.254 13.126,16.135  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 19.859,15.254 18.436,15.254 16.524,17.884  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 13.809,
    y1: 15.254,
    x2: 18.435,
    y2: 15.254
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking1);
export default __webpack_public_path__ + "static/media/working1.2b6cda0c691124ff3e4368e7e55b6e90.svg";
export { ForwardRef as ReactComponent };